<template>
  <el-tabs v-model="tabPaneVal" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="实际承运人资料" name="DriverEdit">
      <compEdit
        v-if="isDriverEditShow"
        ref="DriverEditRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane v-if="ctmsShow" label="常跑线路" name="VehicleTeam">
      <compCommonRoutInfoList
        v-if="isVehicleTeamShow"
        ref="VehicleTeamRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="申请加入车队" name="ApplyToTeam">
      <compApplyToVehicleTeam
        v-if="isApplyToTeamShow"
        ref="ApplyToTeamRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="申请记录" name="ApplyTeamRecord">
      <compApplyRecord
        v-if="isApplyTeamRecordShow"
        ref="ApplyTeamRecordRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane label="我的车辆" name="MyVehicleTeam">
      <compMyVehicleTeam
        v-if="isMyVehicleTeamShow"
        ref="MyVehicleTeamRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
    <el-tab-pane v-if="ctmsShow" label="我的承运分组" name="MyCarrierGroup">
      <compMyCarrierGroup
        v-if="isMyCarrierGroupShow"
        ref="MyCarrierGroupRef"
        :parent-data="parentData"
      />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import compEdit from "./components/driverEdit.vue";
import compCommonRoutInfoList from "./components/commonRouteInfo/commonRouteInfoList";
import compApplyToVehicleTeam from "./components/vehicleTeam/applyToVehicleTeam";
import compApplyRecord from "./components/vehicleTeam/applyRecord";
import compMyVehicleTeam from "./components/vehicleTeam/myVehicleTeam";
import compMyCarrierGroup from "./components/vehicleTeam/myCarrierGroup";
import { getListDict } from "@/api/commonApi";
import { getRole } from "@/utils/getRole";
export default {
  name: "EditDriverForm",
  components: {
    compEdit,
    compCommonRoutInfoList,
    compApplyToVehicleTeam,
    compApplyRecord,
    compMyVehicleTeam,
    compMyCarrierGroup
  },
  data() {
    return {
      tabPaneVal: "DriverEdit",
      isDriverEditShow: true,
      isVehicleTeamShow: false,
      isApplyToTeamShow: false,
      isApplyTeamRecordShow: false,
      isMyVehicleTeamShow: false,
      isMyCarrierGroupShow: false,
      ctmsShow: true,
      parentData: {
        isDetail: false,
        areaOptions: this.$store.state.components.areaOptions,
        vehicleTypeAllowList: [],
        vehicleClassificationList: [],
        vehicleLengthList: [],
        vehicleWidthList: [],
        vehicleHighList: [],
        vehicleTonnageList: [],
        locationSourceList: [],
        vehicleLicenseColorList: [],
        vehicleEnergyTypeList: []
      }
    };
  },
  created() {
    let isCtmsShow = getRole();
    this.ctmsShow = !isCtmsShow;
    // 获取数据字典： 准驾车型，车型，车长，车宽，车高，吨位，定位来源，能源类型，颜色
    getListDict({
      types:
        "vehicleTypeAllow,vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleEnergyType,vehicleLicenseColor"
    }).then(response => {
      this.parentData.vehicleTypeAllowList = response.data.filter(
        item => item.type === "vehicleTypeAllow"
      )[0]["dictList"];
      this.parentData.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
      this.parentData.vehicleLengthList = response.data.filter(
        item => item.type === "vehicleLength"
      )[0]["dictList"];
      this.parentData.vehicleWidthList = response.data.filter(
        item => item.type === "vehicleWidth"
      )[0]["dictList"];
      this.parentData.vehicleHighList = response.data.filter(
        item => item.type === "vehicleHigh"
      )[0]["dictList"];
      this.parentData.vehicleTonnageList = response.data.filter(
        item => item.type === "vehicleTonnage"
      )[0]["dictList"];
      this.parentData.locationSourceList = response.data.filter(
        item => item.type === "locationSource"
      )[0]["dictList"];
      this.parentData.vehicleEnergyTypeList = response.data.filter(
        item => item.type === "vehicleEnergyType"
      )[0]["dictList"];
      this.parentData.vehicleLicenseColorList = response.data.filter(
        item => item.type === "vehicleLicenseColor"
      )[0]["dictList"];
    });
  },
  methods: {
    handleClick(tab, event) {
      this[`is${tab.name}Show`] = true;
      this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList();
      });
    }
  }
};
</script>
